import { render, staticRenderFns } from "./ContestCategoryComponent.vue?vue&type=template&id=25ccba89"
import script from "./ContestCategoryComponent.vue?vue&type=script&lang=js"
export * from "./ContestCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports